import { render, staticRenderFns } from "./BlacklistImei.vue?vue&type=template&id=0abe2ad2&"
import script from "./BlacklistImei.vue?vue&type=script&lang=js&"
export * from "./BlacklistImei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports